import { DEFAULT_LOCALE } from '../i18n'

/** Locale string for @vuepic/vue-datepicker (pt / es / en). */
const DP_LOCALE = {
  'pt-BR': 'pt',
  es: 'es',
  en: 'en'
}

export function datePickerLocaleFor(appLocale) {
  return DP_LOCALE[appLocale] || DP_LOCALE[DEFAULT_LOCALE]
}
